import React, { useMemo, useState } from 'react';
import { Hint, RadialChart } from 'react-vis';
import randomColor from 'randomcolor';

import type { FC } from 'react';
import type {
  ICcmPatientsByInsurances,
  IRpmPatientsByInsurances,
} from 'infrastructure/interfaces';

type TInsuranceBlock = ICcmPatientsByInsurances[] | IRpmPatientsByInsurances[];

const colors: Record<string, string> = {};
const getColorByKey = (key: string) => {
  if (!colors[key]) colors[key] = randomColor({ seed: `${key + key}123` });
  return colors[key];
};

interface InsuranceTypeChartProps {
  insuranceBlocks: TInsuranceBlock;
}
const InsuranceTypeChart: FC<InsuranceTypeChartProps> = ({
  insuranceBlocks,
}) => {
  const [disabledKeys, setDisabledKeys] = useState<string[]>([]);
  const [hintState, setHintState] = useState({
    show: false,
    value: {},
  });

  const chartData = useMemo(() => {
    return insuranceBlocks.map(({ count, provider }, idx) => ({
      key: String(idx),
      angle: count,
      label: provider,
      color: getColorByKey(provider),
      value: {
        Status: provider,
        Patients: count,
      },
    }));
  }, [insuranceBlocks]);
  return (
    <div className="onboarding-chart">
      <RadialChart
        className="radial-chart-with-hover"
        data={chartData.filter((item) => !disabledKeys.includes(item.key))}
        width={220}
        height={220}
        colorType="literal"
        onValueMouseOver={({ value }) => {
          setHintState({ show: true, value });
        }}
        onValueMouseOut={() => {
          setHintState({ show: false, value: {} });
        }}
      >
        {hintState.show && <Hint value={hintState.value} />}
      </RadialChart>
      <div className="onboarding-chart-legend">
        {chartData.map(({ key, color, label }) => (
          <div
            key={key}
            className="onboarding-chart-legend-item"
            style={{
              cursor: 'pointer',
              textDecoration: disabledKeys.includes(key)
                ? 'line-through'
                : 'none',
            }}
            onClick={() => {
              if (disabledKeys.includes(key)) {
                setDisabledKeys(disabledKeys.filter((item) => item !== key));
              } else {
                setDisabledKeys([...disabledKeys, key]);
              }
            }}
          >
            <div
              style={{ backgroundColor: color }}
              className="onboarding-chart-legend-item-dot"
            />
            <div className="onboarding-chart-legend-item-title">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsuranceTypeChart;
